"use client";

import { Dialog, DialogContent } from "@components/core/DialogWrapper";
import clsx from "clsx";
import { ChevronLeft } from "lucide-react";
import { VisuallyHidden } from "react-aria-components";
// TODO: migrate to react aria alternative
import { DialogTitle } from "@radix-ui/react-dialog";

export interface ImpactDetailPopupLayoutProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  dialogTitle: string;
  hasSelection: boolean;
  leftPanel: React.ReactNode;
  rightPanel: React.ReactNode;
  onBack?: () => void;
  backButtonLabel?: string;
}

export default function ImpactDetailPopupLayout({
  open,
  onOpenChange,
  dialogTitle,
  hasSelection,
  leftPanel,
  rightPanel,
  onBack,
  backButtonLabel,
}: ImpactDetailPopupLayoutProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className='flex h-[90vh] max-w-[1000px] flex-col overflow-hidden rounded-xl md:h-[650px] md:flex-row'
        closeButtonVariant='inside'
      >
        <VisuallyHidden>
          <DialogTitle>{dialogTitle}</DialogTitle>
        </VisuallyHidden>
        {/* Left Sidebar */}
        <div
          className={clsx(
            "flex w-full flex-1 flex-col border-r bg-dark md:w-1/3 md:max-w-[300px]",
            hasSelection && "hidden md:flex",
          )}
        >
          <div className='flex h-full max-h-[700px] w-full flex-1 flex-col'>{leftPanel}</div>
        </div>

        {/* Right Content Area */}
        <div className={clsx("flex flex-1 flex-col overflow-y-auto", !hasSelection && "hidden md:flex")}>
          {hasSelection && (
            <>
              <div className='h-44 shrink-0 lg:hidden' />
              {onBack && backButtonLabel && (
                <button
                  className='effect-focus f-ui-02 absolute left-0 top-8 flex items-center gap-8 px-24 py-20 text-default transition-colors hover:text-light md:hidden'
                  type='button'
                  onClick={onBack}
                >
                  <ChevronLeft className='size-20' />
                  {backButtonLabel}
                </button>
              )}
              {rightPanel}
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
